import React from 'react'
import moment from 'moment';
import GatsbyLink from '../../GatsbyLink';
import RenderContent from '../../RenderContent';
import { Image } from '../../Image';
import { FaChevronRight } from 'react-icons/fa';
import './PostListItem.scss'
import { decodeEntities } from '../../../utils/helpers';

export default class ListItem extends React.Component {
  render () {
    const { siteMetadata, data, pathPrefix, showAuthor } = this.props;
    const { excerpt, title, slug, featured_image_url, author, date } = data;
    return (
      <div className="post-list-item yessir">
        <div>
          <div className="image"><GatsbyLink to={pathPrefix === "project-gallery" ? `/project-gallery/${slug}/` : `/${slug}/`}  label={title}><Image src={featured_image_url} className="background" /></GatsbyLink></div>
          <div className="inner">
            {/* {date && <span className="date">{date}</span>} */}
            <h4 className="title"><GatsbyLink to={pathPrefix === "project-gallery" ? `/project-gallery/${slug}/` : `/${slug}/`} >{decodeEntities(title)}</GatsbyLink></h4>
            {slug && <GatsbyLink to={pathPrefix === "project-gallery" ? `/project-gallery/${slug}/` : `/${slug}/`} label={title} className="post-link">{pathPrefix === '' ? 'READ MORE' : 'SEE PROJECT'}</GatsbyLink>}
          </div>
        </div>
      </div>
    )
  }
}
